export function getKeyName(enumObject: object, value: string) {
  return Object.entries(enumObject).find(([, val]) => val === value)?.[0];
}
